import React from 'react';
import MessagesContainer from '../components/messages/MessagesContainer';

const Messages = () => (
  <MessagesContainer />
);

export default Messages;
